import type React from 'react';
import styled from 'styled-components';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity.ts';
import { observer } from 'mobx-react';
import { useInjection } from 'inversify-react';
import type { ViewsListController } from '@/engine/app/ViewsList.controller';
import { TYPES } from '@/engine/ioc';

export const ViewsList: React.FC = observer(() => {
  const viewsListController = useInjection<ViewsListController>(TYPES.ViewsListController);
  const views: Array<ViewEntity> = viewsListController.views;
  const selectedView: ViewEntity | null = viewsListController.currentView;
  return (
    <Container>
      <List component="nav">
        {views.map((v) => {
          return (
            <ListItemButton
              onClick={(): void => viewsListController.setCurrentView(v)}
              key={v.getDescriptor()}
              selected={v === selectedView}
            >
              <ListItemText>{v.getLabel() + ' view'}</ListItemText>
            </ListItemButton>
          );
        })}
      </List>
    </Container>
  );
});

const Container = styled.div``;
